###
###
module.exports = Em.Service.extend
  ymapsInstance: null
  loadDeferred:  null

  env:     Em.inject.service('environment')
  session: Em.inject.service('session')
  notifier: Em.inject.service('notifier')

  lang: (->
    navigator.language || navigator.userLanguage;
  ).property('navigator.language','navigator.userLanguage')


  retrieve: ->
    if @get('loadDeferred')
      return @get('loadDeferred').promise

    deferred = Em.RSVP.defer()
    @set('loadDeferred', deferred)

    if @get('ymapsInstance')
      deferred.resolve( @get('ymapsInstance') )
      return

    callbackName = "__onYmapsInit_#{ Math.floor( Math.random() * 0xffffff ) }"

    window[ callbackName ] = =>
      Em.Logger.log 'Яндекс.Карты загружены'
      @set('ymapsInstance', window.ymaps)
      deferred.resolve( @get('ymapsInstance') )

    env = @get('env')
    notifier = @get('notifier')

    console.warn = (message) ->
      if message == '(Yandex Maps JS API): Invalid API key'
        title = env.translate('delivery.notifications.ymaps.title')
        errorMessage = env.translate('delivery.notifications.ymaps.message')
        notifier.pushNotification({type: 'error', duration: 15000, title, message: errorMessage})

    # hatlam
    Em.$.getScript("https://api-maps.yandex.ru/2.1/?apikey=#{@get('session.yandex_token')}&suggest_apikey=#{@get('session.yandex_token')}&lang=#{@get('lang')}&onload=#{ callbackName }")
    deferred.promise




